<template>
  <v-form ref="form" v-model="valid">
    <v-card elevation="0" max-width="1000">
      <v-card-text>
        <v-row>
          <v-col>
            <v-select
              v-model="data.prjStYy"
              :items="years"
              :rules="[rules.required]"
              label="연도"
              clearable
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="data.prjNm"
              :rules="[rules.required]"
              label="프로젝트명"
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-for="(test, i) in testUrl" :key="`test${i}`">
          <v-col cols="7">
            <v-text-field
              v-model="test.url"
              label="테스트서버 URL"
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="test.note"
              label="설명"
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="1" align-self="center">
            <template v-if="i === 0">
              <v-btn fab small elevation="0" @click="addUrl('test')">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <template v-else>
              <v-btn fab small elevation="0" @click="removeUrl('test')">
                <v-icon>mdi-minus</v-icon>
              </v-btn>
            </template>
          </v-col>
        </v-row>
        <v-row v-for="(real, i) in realUrl" :key="`real${i}`">
          <v-col cols="7">
            <v-text-field
              v-model="real.url"
              label="실서버 URL"
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="real.note"
              label="설명"
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="1" align-self="center">
            <template v-if="i === 0">
              <v-btn fab small elevation="0" @click="addUrl('real')">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <template v-else>
              <v-btn fab small elevation="0" @click="removeUrl('real')">
                <v-icon>mdi-minus</v-icon>
              </v-btn>
            </template>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea v-model="data.note" label="비고" clearable></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-select
              v-model="data.empList"
              :items="employee"
              item-text="empNm"
              item-value="empNo"
              label="참여 직원"
              multiple
              clearable
              chips
              deletable-chips
              return-object
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <v-btn to="/project/list" elevation="0" outlined color="primary">
          취소
        </v-btn>
        <v-btn elevation="0" color="primary" @click="onSubmit">저장</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import moment from "moment";
import { getEmp } from "@/api/common.js";
import { modiPrj, setPrj } from "@/api/project";

export default {
  data() {
    return {
      data: {
        prjStYy: moment()
          .year()
          .toString(),
        prjNm: null,
        note: "",
        empList: [],
        urlList: [],
        prjStCd: 200,
      },
      testUrl: [{ url: "", note: "", urlUseCd: 105100 }],
      realUrl: [{ url: "", note: "", urlUseCd: 105101 }],
      search: null,
      employee: [],
      valid: true,
      rules: {
        required: value => !!value || "필수 항목입니다.",
      },
      snackbar: {
        show: false,
        message: "",
      },
    };
  },
  props: ["isShow", "isModi", "projects"],
  watch: {
    isShow(newVal) {
      if (!newVal) {
        this.reset();
        this.getEmpList();
      }
    },
    isModi(newVal) {
      if (newVal) {
        this.data = this.projects;
      }
    },
  },
  computed: {
    years() {
      const curYear = moment().year();
      let arrYear = [];

      for (let i = 2011; i <= curYear; i++) {
        arrYear.push(i.toString());
      }

      return arrYear.reverse();
    },
  },
  mounted() {
    this.reset();
    this.getEmpList();
    if (this.isModi) {
      this.data = this.projects;
    }
  },
  methods: {
    showAlert(msg) {
      this.snackbar.show = true;
      this.snackbar.message = msg;
    },
    reset() {
      this.$refs.form.resetValidation();
      Object.assign(this.$data, this.$options.data());
    },
    addUrl(type) {
      // url 입력항목 추가
      const code = type === "test" ? 105100 : 105101;
      this[`${type}Url`].push({ url: "", note: "", urlUseCd: code });
    },
    removeUrl(type) {
      // url 입력항목 삭제
      const count = this[`${type}Url`].length;
      this[`${type}Url`].splice(count - 1, 1);
    },
    async getEmpList() {
      // 참여 직원 조회
      try {
        const { data } = await getEmp();
        const newData = data.list.map(v => {
          return { empNo: v.empNo, empNm: v.empNm };
        });

        this.employee = newData;
      } catch (err) {
        console.error(err);
      }
    },
    async onSubmit() {
      this.$refs.form.validate();
      if (!this.valid) return false;

      const testUrl = this.testUrl.filter(v => !!v.url && v.url !== "");
      const realUrl = this.realUrl.filter(v => !!v.url && v.url !== "");
      const urlList = testUrl.concat(realUrl);

      this.data.urlList = urlList;

      try {
        const { data } = !this.isModi
          ? await setPrj(this.data)
          : await modiPrj(this.prjNo, this.data);

        if (data.ret === 1) {
          this.showAlert("저장되었습니다.");
          this.loadList();
          this.hideModal();
        } else {
          this.showAlert("저장 실패.");
          this.hideModal();
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style></style>
